export default __webpack_public_path__ + "static/API-07e8ae684b39860894083148a385d9d0.gif";